// Bloomberg-style tickers → Yahoo symbols. Users can type either; the
// panel shows the Bloomberg-ish form where we know one.

export interface Alias {
  bbg: string; // e.g. "SPX Index"
  yahoo: string; // e.g. "^GSPC"
  name: string;
}

export const ALIASES: Alias[] = [
  // US equity indices
  { bbg: "SPX Index", yahoo: "^GSPC", name: "S&P 500" },
  { bbg: "INDU Index", yahoo: "^DJI", name: "Dow Jones Industrial Average" },
  { bbg: "CCMP Index", yahoo: "^IXIC", name: "Nasdaq Composite" },
  { bbg: "NDX Index", yahoo: "^NDX", name: "Nasdaq 100" },
  { bbg: "RTY Index", yahoo: "^RUT", name: "Russell 2000" },
  { bbg: "VIX Index", yahoo: "^VIX", name: "CBOE Volatility Index" },
  { bbg: "SOX Index", yahoo: "^SOX", name: "PHLX Semiconductor" },
  // Americas
  { bbg: "SPTSX Index", yahoo: "^GSPTSE", name: "S&P/TSX Composite" },
  { bbg: "IBOV Index", yahoo: "^BVSP", name: "Ibovespa" },
  { bbg: "MEXBOL Index", yahoo: "^MXX", name: "S&P/BMV IPC" },
  // EMEA
  { bbg: "SX5E Index", yahoo: "^STOXX50E", name: "Euro Stoxx 50" },
  { bbg: "SXXP Index", yahoo: "^STOXX", name: "Stoxx Europe 600" },
  { bbg: "UKX Index", yahoo: "^FTSE", name: "FTSE 100" },
  { bbg: "DAX Index", yahoo: "^GDAXI", name: "DAX" },
  { bbg: "CAC Index", yahoo: "^FCHI", name: "CAC 40" },
  { bbg: "IBEX Index", yahoo: "^IBEX", name: "IBEX 35" },
  { bbg: "FTSEMIB Index", yahoo: "FTSEMIB.MI", name: "FTSE MIB" },
  { bbg: "AEX Index", yahoo: "^AEX", name: "AEX" },
  { bbg: "SMI Index", yahoo: "^SSMI", name: "Swiss Market Index" },
  // APAC
  { bbg: "NKY Index", yahoo: "^N225", name: "Nikkei 225" },
  { bbg: "TPX Index", yahoo: "^TOPX", name: "TOPIX" },
  { bbg: "HSI Index", yahoo: "^HSI", name: "Hang Seng" },
  { bbg: "SHCOMP Index", yahoo: "000001.SS", name: "Shanghai Composite" },
  { bbg: "SZCOMP Index", yahoo: "399001.SZ", name: "Shenzhen Component" },
  { bbg: "KOSPI Index", yahoo: "^KS11", name: "KOSPI" },
  { bbg: "TWSE Index", yahoo: "^TWII", name: "Taiwan Weighted" },
  { bbg: "AS51 Index", yahoo: "^AXJO", name: "S&P/ASX 200" },
  { bbg: "SENSEX Index", yahoo: "^BSESN", name: "BSE Sensex" },
  { bbg: "NIFTY Index", yahoo: "^NSEI", name: "Nifty 50" },
  { bbg: "STI Index", yahoo: "^STI", name: "Straits Times" },
  // Rates (Yahoo's CBOE yield indices, in percent)
  { bbg: "USGG3M Index", yahoo: "^IRX", name: "US 13-week T-bill yield" },
  { bbg: "USGG5YR Index", yahoo: "^FVX", name: "US 5-year yield" },
  { bbg: "USGG10YR Index", yahoo: "^TNX", name: "US 10-year yield" },
  { bbg: "USGG30YR Index", yahoo: "^TYX", name: "US 30-year yield" },
  // Dollar
  { bbg: "DXY Curncy", yahoo: "DX-Y.NYB", name: "US Dollar Index" },
  // Equity index futures
  { bbg: "ES1 Index", yahoo: "ES=F", name: "E-mini S&P 500 future" },
  { bbg: "NQ1 Index", yahoo: "NQ=F", name: "E-mini Nasdaq 100 future" },
  { bbg: "DM1 Index", yahoo: "YM=F", name: "E-mini Dow future" },
  { bbg: "RTY1 Index", yahoo: "RTY=F", name: "E-mini Russell 2000 future" },
  // Commodities, front month
  { bbg: "CL1 Comdty", yahoo: "CL=F", name: "WTI crude oil" },
  { bbg: "CO1 Comdty", yahoo: "BZ=F", name: "Brent crude oil" },
  { bbg: "NG1 Comdty", yahoo: "NG=F", name: "Natural gas" },
  { bbg: "HO1 Comdty", yahoo: "HO=F", name: "Heating oil" },
  { bbg: "XB1 Comdty", yahoo: "RB=F", name: "RBOB gasoline" },
  { bbg: "GC1 Comdty", yahoo: "GC=F", name: "Gold" },
  { bbg: "SI1 Comdty", yahoo: "SI=F", name: "Silver" },
  { bbg: "HG1 Comdty", yahoo: "HG=F", name: "Copper" },
  { bbg: "PL1 Comdty", yahoo: "PL=F", name: "Platinum" },
  { bbg: "PA1 Comdty", yahoo: "PA=F", name: "Palladium" },
  { bbg: "C 1 Comdty", yahoo: "ZC=F", name: "Corn" },
  { bbg: "W 1 Comdty", yahoo: "ZW=F", name: "Wheat" },
  { bbg: "KW1 Comdty", yahoo: "KE=F", name: "KC HRW wheat" },
  { bbg: "S 1 Comdty", yahoo: "ZS=F", name: "Soybeans" },
  { bbg: "SM1 Comdty", yahoo: "ZM=F", name: "Soybean meal" },
  { bbg: "BO1 Comdty", yahoo: "ZL=F", name: "Soybean oil" },
  { bbg: "KC1 Comdty", yahoo: "KC=F", name: "Coffee" },
  { bbg: "SB1 Comdty", yahoo: "SB=F", name: "Sugar" },
  { bbg: "CC1 Comdty", yahoo: "CC=F", name: "Cocoa" },
  { bbg: "CT1 Comdty", yahoo: "CT=F", name: "Cotton" },
  { bbg: "JO1 Comdty", yahoo: "OJ=F", name: "Orange juice" },
  { bbg: "LC1 Comdty", yahoo: "LE=F", name: "Live cattle" },
  { bbg: "FC1 Comdty", yahoo: "GF=F", name: "Feeder cattle" },
  { bbg: "LH1 Comdty", yahoo: "HE=F", name: "Lean hogs" },
  { bbg: "TY1 Comdty", yahoo: "ZN=F", name: "10-year T-note future" },
  { bbg: "US1 Comdty", yahoo: "ZB=F", name: "T-bond future" },
  // Crypto
  { bbg: "XBTUSD Curncy", yahoo: "BTC-USD", name: "Bitcoin" },
  { bbg: "XETUSD Curncy", yahoo: "ETH-USD", name: "Ether" },
];

const byBbgRoot = new Map<string, Alias>();
const byYahoo = new Map<string, Alias>();
for (const a of ALIASES) {
  const root = a.bbg.replace(/ (Index|Comdty|Curncy|Equity)$/, "").toUpperCase();
  byBbgRoot.set(root, a);
  byYahoo.set(a.yahoo, a);
}

const YELLOW_KEYS = ["EQUITY", "INDEX", "COMDTY", "CURNCY", "GOVT", "CORP", "MTGE", "MUNI", "PFD", "M-MKT"];
/// Bloomberg exchange codes → Yahoo suffix.
const EXCH: Record<string, string> = {
  US: "", UN: "", UW: "", UQ: "", UA: "", UP: "",
  LN: ".L", GY: ".DE", GR: ".DE", FP: ".PA", NA: ".AS", SM: ".MC", IM: ".MI", SW: ".SW", SE: ".SW",
  JP: ".T", JT: ".T", HK: ".HK", CN: ".TO", CT: ".TO", AU: ".AX", AT: ".AX", KS: ".KS", TT: ".TW",
  IN: ".NS", IB: ".BO", SS: ".ST", NO: ".OL", DC: ".CO", FH: ".HE", BB: ".BR", ID: ".IR", PL: ".LS",
};

/// Turn what the user typed (tokens, already upper-cased) into a Yahoo
/// symbol, or null if it doesn't look like one.
export function resolve(tokens: string[]): string | null {
  if (tokens.length === 0) return null;
  const toks = [...tokens];
  const yellow = YELLOW_KEYS.includes(toks[toks.length - 1]) ? toks.pop()! : null;
  if (toks.length === 0) return null;

  const joined = toks.join(" ");
  // "C 1 Comdty" style roots contain a space.
  const alias = byBbgRoot.get(joined) ?? byBbgRoot.get(toks[0]);
  if (alias && (toks.length === 1 || byBbgRoot.has(joined))) return alias.yahoo;

  if (yellow === "CURNCY" && /^[A-Z]{6}$/.test(toks[0])) {
    return toks[0].startsWith("USD") ? `${toks[0].slice(3)}=X` : `${toks[0]}=X`;
  }
  if (toks.length === 2 && toks[1] in EXCH) {
    // "BRK/B US" → "BRK-B"
    return toks[0].replace("/", "-") + EXCH[toks[1]];
  }
  if (toks.length === 1 && /^[A-Z0-9^][A-Z0-9.^=&_/-]{0,23}$/.test(toks[0])) {
    return toks[0].replace("/", "-");
  }
  return null;
}

export function aliasFor(yahoo: string): Alias | undefined {
  return byYahoo.get(yahoo);
}

/// Bloomberg-ish display name for a Yahoo symbol.
export function display(yahoo: string, quoteType?: string): string {
  const a = byYahoo.get(yahoo);
  if (a) return a.bbg;
  if (yahoo.endsWith("=X")) return `${yahoo.slice(0, -2).padStart(6, "USD")} Curncy`;
  if (quoteType === "EQUITY" || quoteType === "ETF") {
    return yahoo.includes(".") ? `${yahoo} Equity` : `${yahoo} US Equity`;
  }
  if (quoteType === "CRYPTOCURRENCY") return `${yahoo} Curncy`;
  if (quoteType === "FUTURE") return `${yahoo} Comdty`;
  if (quoteType === "INDEX") return `${yahoo} Index`;
  return yahoo;
}

/// Local matches for autocomplete, before the server search comes back.
export function localMatches(text: string, limit = 6): Alias[] {
  const t = text.toUpperCase();
  if (!t) return [];
  return ALIASES.filter(
    (a) => a.bbg.toUpperCase().startsWith(t) || a.name.toUpperCase().includes(t) || a.yahoo.startsWith(t),
  ).slice(0, limit);
}
